var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rests
    ? _c(
        "div",
        {
          staticClass: "wrapper",
          staticStyle: {
            background: "#E6F7FF",
            width: "100%",
            display: "flex",
            "line-height": "40px"
          }
        },
        [
          _c("div", { staticClass: "content" }, [
            _vm.types == 0
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v(" "),
                  _c("span", { attrs: { "ml-2": "" } }, [_vm._v("当前共有")]),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 0
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      车辆总数："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 1
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _c("span", { attrs: { "ml-2": "" } }, [_vm._v("当前共有")]),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 1
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      司机总数："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 2
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("未处理车辆违章数量总计"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 3
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("已处理车辆违章数量总计"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum + _vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 4
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 4
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      销户车辆总数："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("台\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 5
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("条年审信息\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 5
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      本月年审即将到期："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 6
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("条保险信息\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 6
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      本月保险即将到期："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 7
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("条保养信息\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 7
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      本月保养即将到期："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 8
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个合同\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 8
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      机械使用确认单总数："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 9
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("条机械使用确认单\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 9
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      累计工作时长："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("小时\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 10
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("条结算单\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 10
              ? _c("div", { attrs: { md4: "" } }, [
                  _vm._v("\n      机械使用确认单总数："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 11
              ? _c("div", { attrs: { md3: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 11
              ? _c("div", { attrs: { md3: "" } }, [
                  _vm._v("\n      车辆违章数量："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 12
              ? _c("div", { attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 12
              ? _c("div", { attrs: { md4: "" } }, [
                  _vm._v("\n      安全责任承诺书数量："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("份\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 13
              ? _c("div", { attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 13
              ? _c("div", { attrs: { md4: "" } }, [
                  _vm._v("\n      动态监控工作制度文件数量："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("份\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 14
              ? _c("div", { attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 14
              ? _c("div", { attrs: { md4: "" } }, [
                  _vm._v("\n      人员变动书面报告数量："),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("份\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 15
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 15
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      立项文件数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("份\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 16
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 16
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      评审文件数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("份\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 17
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 17
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      文件数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("份\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 18
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 18
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      合同数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 19
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("共"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条年检报表\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 20
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("共"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 21
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 21
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      签认统计表数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 22
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 22
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      合同数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 23
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 23
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      签认单数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 24
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: "blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 24
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      任务数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 25
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 25
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _vm._v("\n      车辆总数："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("台\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 26
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个终端\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 27
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条绑定记录\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 28
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      员工数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 29
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      设备调度数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 30
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      交接鉴定表数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 31
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      签认单数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 32
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      签认表数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("个\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 33
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      租赁设备数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("台\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 34
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      确认表数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("张\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 35
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      支付汇总表数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("张\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 36
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      申请单数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("张\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 37
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      启用单数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("张\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 38
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      机汇云盒数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("台\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 39
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      签认单数量："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("张\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 40
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前出租单位共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("台设备\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 41
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前出租单位共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("名员工\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 42
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 42
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("span", [
                    _vm._v("设备总数："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.total || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("自有设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.selfNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("外租设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.rentNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("外协设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.otherNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("安装了物联网终端："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.terminalNum || 0))
                    ]),
                    _vm._v("台")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 43
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条熄火怠速预警\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 44
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条机况参数预警\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 45
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条燃油预警\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 46
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条运输记录\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 47
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条异常信息\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 48
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条异常提醒\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 49
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n      "),
                  _c("span", {
                    staticStyle: { display: "inline-block", width: "20px" }
                  }),
                  _vm._v("\n      加油记录："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("条\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 51
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("span", [
                    _vm._v("机汇云盒数量："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.terminalNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("跨云数据对接数量："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.cloudNum || 0))
                    ]),
                    _vm._v("台")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 52
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("span", [
                    _vm._v("设备总数："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.total || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("自有设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.selfNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("外租设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.rentNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("外协设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.otherNum || 0))
                    ]),
                    _vm._v("台，")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 53
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v(
                    "个单位 设备数量：" + _vm._s(_vm.vehicleNum) + "台\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 54
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v(
                    "个单位 租赁设备数量：" +
                      _vm._s(_vm.vehicleNum) +
                      "台\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 55
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 55
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("span", [
                    _vm._v("设备总数："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.total || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("外租设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.rentNum || 0))
                    ]),
                    _vm._v("台")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 56
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 56
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("span", [
                    _vm._v("设备总数："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.total || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("自有设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.selfNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("外租设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.rentNum || 0))
                    ]),
                    _vm._v("台，")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("外协设备："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.otherNum || 0))
                    ]),
                    _vm._v("台")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 57
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前共有："),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.deptNum))
                  ]),
                  _vm._v("个单位\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 57
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("span", [
                    _vm._v("全部评审文件数量："),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.total || 0))
                    ]),
                    _vm._v("个")
                  ]),
                  _vm._v("\n       \n      "),
                  _c("span", [
                    _vm._v("流标/作废"),
                    _c("span", { staticClass: " blue--text" }, [
                      _vm._v(_vm._s(_vm.cancel || 0))
                    ]),
                    _vm._v("个")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 60
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前运输单位共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("台设备\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 61
              ? _c("div", { staticClass: "text-xs-left" }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v("当前运输单位共有"),
                  _c("span", { staticClass: " blue--text" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _vm._v("名员工\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.types == 999
              ? _c("div", { staticClass: "text-xs-left", attrs: { md2: "" } }, [
                  _c("i", { staticClass: "el-icon-info blue--text" }),
                  _vm._v(
                    "温馨提示：如果您已经在系统中完成了租赁询比价，请到‘合同制作’模块完善合同信息，无需再次手动编制合同。\n    "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn" },
            [
              _vm.types == 999
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.go()
                        }
                      }
                    },
                    [_vm._v("去完善")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.rest()
                        }
                      }
                    },
                    [_vm._v("清空")]
                  )
            ],
            1
          )
        ]
      )
    : _c("div", { staticStyle: { height: "20px" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }